import {
  AnticipatedMonthlySpend,
  ApplicationCustomerDetailsEntity,
  ApplicationEntity,
  BordierOffice,
  NetWorth,
  SourceOfWealthValue,
  SupplementaryApplicationEntity,
} from '@shared/api';

export interface ISupplementaryApplicationFormStep1 {
  mainTitle: string;
  mainFirstName: string;
  mainMiddleName: string;
  mainLastName: string;
  lastFourNumberOfCard: string;
  relationshipToMain: string;
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  nameOnCard: string;
  nationality: string;
  countryOfBirth: string;
  maritalStatus: string;
  dob: string;
  passport_IDCardNo: string;
  countryOfIssuance: string;
  passportExpiryDate: string;
  nationalities: string[];
  residentialAddressLine1: string;
  residentialAddressLine2: string;
  city: string;
  postcode: string;
  country: string;
  alternativeMailingAddressLine1: string;
  alternativeMailingAddressLine2: string;
  alternativeMailingAddressCity: string;
  alternativeMailingAddressPostcode: string;
  alternativeMailingAddressCountry: string;
  mobileAreaCode: string;
  mobileNumber: string;
  alternateAreaCode: string;
  alternativeContactNumber: string;
  email: string;
  anticipatedMonthlySpend: string;
  pep: boolean;
  pepRolePosition: string;
  currentPepDate?: string;
  formerPep?: boolean;
  formerPepPosition?: string;
  formerPepDate?: string;
  familyPep?: boolean;
  familyPepRelationship?: string;
  familyPepPosition?: string;
  familyPepDate?: string;
  closeAssociatePep?: boolean;
  closeAssociatePepRelationship?: string;
  closeAssociatePepPosition?: string;
  closeAssociatePepDate?: string;
  securityQuestion: string;
  securityAnswer: string;
}

export interface ISupplementaryApplicationFormStep2 {
  acceptedTC: boolean;
}

export interface IApplicationFormStep1 {
  partnerAccountManagerId: string;
  partnerAccountManagerName: string;
  ippGroup: string;
  productName: string;
  fee: boolean;
  eurCurrency: boolean;
  eurCreditLimit: string;
  chfCurrency: boolean;
  chfCreditLimit: string;
  usdCurrency: boolean;
  usdCreditLimit: string;
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  nameOnCard: string;
  nationality: string;
  countryOfBirth: string;
  maritalStatus: string;
  dob: string;
  passport_IDCardNo: string;
  countryOfIssuance: string;
  passportExpiryDate: string;
  nationalities: string[];
  residentialAddressLine1: string;
  residentialAddressLine2: string;
  city: string;
  postcode: string;
  country: string;
  alternativeMailingAddressLine1: string;
  alternativeMailingAddressLine2: string;
  alternativeMailingAddressCity: string;
  alternativeMailingAddressPostcode: string;
  alternativeMailingAddressCountry: string;
  employmentStatus: string;
  employmentStatusOther: string;
  positionHeld: string;
  companyName: string;
  employmentDuration: string;
  natureOfBusiness: string;
  companyWebsite: string;
  mobileAreaCode: string;
  mobileNumber: string;
  alternateAreaCode: string;
  alternativeContactNumber: string;
  email: string;
  deliveryAddress: string;
  deliveryBordierOffice: BordierOffice;
  personalAssistantLanguage: string;
  annualIncomeCurrency: string;
  annualIncomeAmount: string;
  otherIncomeCurrency: string;
  otherIncomeAmount: string;
  sow: SourceOfWealthValue[];
  sof: SourceOfWealthValue[];
  netWorth?: NetWorth;
  bankAccountNumber: string;
  bankAccountNumber2: string;
  anticipatedMonthlySpend: AnticipatedMonthlySpend;
  pep: boolean;
  pepRolePosition: string;
  currentPepDate?: string;
  formerPep?: boolean;
  formerPepPosition?: string;
  formerPepDate?: string;
  familyPep?: boolean;
  familyPepRelationship?: string;
  familyPepPosition?: string;
  familyPepDate?: string;
  closeAssociatePep?: boolean;
  closeAssociatePepRelationship?: string;
  closeAssociatePepPosition?: string;
  closeAssociatePepDate?: string;
  securityQuestion: string;
  securityAnswer: string;
}

export interface IApplicationFormStep2 {
  fraudSMS: boolean;
  creditLimit80PerCentSMS: boolean;
  allTransactionsSMS: boolean;
  marketing: boolean;
  acceptedTC: boolean;
}

export class TransformData {
  static defaultSupplementaryApplication: SupplementaryApplicationEntity = {
    // STEP MAIN CARD HOLDER
    mainTitle: '',
    mainFirstName: '',
    mainMiddleName: '',
    mainLastName: '',
    lastFourNumberOfCard: '',
    relationshipToMain: '',
    // STEP APPLICANT
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    nameOnCard: '',
    nationality: '',
    maritalStatus: '',
    dob: '',
    passport_IDCardNo: '',
    countryOfIssuance: '',
    passportExpiryDate: '',
    nationalities: [''],
    // STEP SUPPLEMENTARY CONTACT
    residentialAddressLine1: '',
    residentialAddressLine2: '',
    city: '',
    postcode: '',
    country: '',
    alternativeMailingAddressLine1: '',
    alternativeMailingAddressLine2: '',
    alternativeMailingAddressCity: '',
    alternativeMailingAddressPostcode: '',
    alternativeMailingAddressCountry: '',
    mobileAreaCode: '',
    mobileNumber: '',
    alternateAreaCode: '',
    alternativeContactNumber: '',
    email: '',
    // STEP ANTICIPATED MONTHLY SPEND
    anticipatedMonthlySpend: '' as AnticipatedMonthlySpend,
    // STEP PEP
    pep: false,
    pepRolePosition: '',
    // currentPepDate: '',
    // formerPep: false,
    // formerPepPosition: '',
    // formerPepDate: '',
    // familyPep: false,
    // familyPepRelationship: '',
    // familyPepPosition: '',
    // familyPepDate: '',
    // closeAssociatePep: false,
    // closeAssociatePepRelationship: '',
    // closeAssociatePepPosition: '',
    // closeAssociatePepDate: '',
    // STEP SECURITY QUESTION
    securityQuestion: '',
    securityAnswer: '',
    // STEP DATA PROTECTION
    acceptedTC: false,
    // OTHER XZ
    fee: true,
    mainAppId: '',
    insertedDate: '',
  };
  static transformSupplementaryApplication = ({
    mainApplicationId,
    application,
    supplementaryApplication,
  }: {
    mainApplicationId: string;
    application: ApplicationEntity;
    supplementaryApplication: SupplementaryApplicationEntity | null;
  }) => {
    return {
      ...supplementaryApplication,
      mainTitle: application.title,
      mainFirstName: application.firstName,
      mainMiddleName: application.middleName,
      mainLastName: application.lastName,
      mainAppId: mainApplicationId,
      partnerAccountManagerId: application.partnerAccountManagerId,
      partnerAccountManagerName: application.partnerAccountManagerName,
      ippGroup: application.ippGroup,
    };
  };
  static defaultSupplementaryApplicationFormStep1: ISupplementaryApplicationFormStep1 = {
    // STEP MAIN CARD HOLDER
    mainTitle: '',
    mainFirstName: '',
    mainMiddleName: '',
    mainLastName: '',
    lastFourNumberOfCard: '',
    relationshipToMain: '',
    // STEP APPLICANT
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    nameOnCard: '',
    nationality: '',
    countryOfBirth: '',
    maritalStatus: '',
    dob: '',
    passport_IDCardNo: '',
    countryOfIssuance: '',
    passportExpiryDate: '',
    nationalities: [''],
    // STEP SUPPLEMENTARY CONTACT
    residentialAddressLine1: '',
    residentialAddressLine2: '',
    city: '',
    postcode: '',
    country: '',
    alternativeMailingAddressLine1: '',
    alternativeMailingAddressLine2: '',
    alternativeMailingAddressCity: '',
    alternativeMailingAddressPostcode: '',
    alternativeMailingAddressCountry: '',
    mobileAreaCode: '',
    mobileNumber: '',
    alternateAreaCode: '',
    alternativeContactNumber: '',
    email: '',
    // STEP ANTICIPATED MONTHLY SPEND
    anticipatedMonthlySpend: '' as AnticipatedMonthlySpend,
    // STEP PEP
    pep: false,
    pepRolePosition: '',
    // currentPepDate: '',
    // formerPep: false,
    // formerPepPosition: '',
    // formerPepDate: '',
    // familyPep: false,
    // familyPepRelationship: '',
    // familyPepPosition: '',
    // familyPepDate: '',
    // closeAssociatePep: false,
    // closeAssociatePepRelationship: '',
    // closeAssociatePepPosition: '',
    // closeAssociatePepDate: '',
    // STEP SECURITY QUESTION
    securityQuestion: '',
    securityAnswer: '',
  };
  static defaultSupplementaryApplicationFormStep2: ISupplementaryApplicationFormStep2 = {
    // STEP DATA PROTECTION
    acceptedTC: false,
  };
  static transformSupplementaryApplicationFormStep1 = (data: SupplementaryApplicationEntity): ISupplementaryApplicationFormStep1 => {
    const dto = {
      mainTitle: data.mainTitle || '',
      mainFirstName: data.mainFirstName || '',
      mainMiddleName: data.mainMiddleName || '',
      mainLastName: data.mainLastName || '',
      lastFourNumberOfCard: data.lastFourNumberOfCard || '',
      relationshipToMain: data.relationshipToMain || '',
      title: data.title || '',
      firstName: data.firstName || '',
      middleName: data.middleName || '',
      lastName: data.lastName || '',
      nameOnCard: data.nameOnCard || '',
      nationality: data.nationality || '',
      countryOfBirth: data.countryOfBirth || '',
      maritalStatus: data.maritalStatus || '',
      dob: data.dob || '',
      passport_IDCardNo: data.passport_IDCardNo || '',
      countryOfIssuance: data.countryOfIssuance || '',
      passportExpiryDate: data.passportExpiryDate || '',
      nationalities: data.nationalities || [''],
      residentialAddressLine1: data.residentialAddressLine1 || '',
      residentialAddressLine2: data.residentialAddressLine2 || '',
      city: data.city || '',
      postcode: data.postcode || '',
      country: data.country || '',
      alternativeMailingAddressLine1: data.alternativeMailingAddressLine1 || '',
      alternativeMailingAddressLine2: data.alternativeMailingAddressLine2 || '',
      alternativeMailingAddressCity: data.alternativeMailingAddressCity || '',
      alternativeMailingAddressPostcode: data.alternativeMailingAddressPostcode || '',
      alternativeMailingAddressCountry: data.alternativeMailingAddressCountry || '',
      mobileAreaCode: data.mobileAreaCode || '',
      mobileNumber: data.mobileNumber || '',
      alternateAreaCode: data.alternateAreaCode || '',
      alternativeContactNumber: data.alternativeContactNumber || '',
      email: data.email || '',
      anticipatedMonthlySpend: data.anticipatedMonthlySpend || '',
      pep: data.pep || false,
      pepRolePosition: data.pepRolePosition || '',
      // currentPepDate: data.currentPepDate || '',
      // formerPep: data.formerPep || false,
      // formerPepPosition: data.formerPepPosition || '',
      // formerPepDate: data.formerPepDate || '',
      // familyPep: data.familyPep || false,
      // familyPepRelationship: data.familyPepRelationship || '',
      // familyPepPosition: data.familyPepPosition || '',
      // familyPepDate: data.familyPepDate || '',
      // closeAssociatePep: data.closeAssociatePep || false,
      // closeAssociatePepRelationship: data.closeAssociatePepRelationship || '',
      // closeAssociatePepPosition: data.closeAssociatePepPosition || '',
      // closeAssociatePepDate: data.closeAssociatePepDate || '',
      securityQuestion: data.securityQuestion || '',
      securityAnswer: data.securityAnswer || '',
    };
    if (data.currentPepDate) (dto as ISupplementaryApplicationFormStep1).currentPepDate = data.currentPepDate;
    if (data.formerPep) (dto as ISupplementaryApplicationFormStep1).formerPep = data.formerPep;
    if (data.formerPepPosition) (dto as ISupplementaryApplicationFormStep1).formerPepPosition = data.formerPepPosition;
    if (data.formerPepDate) (dto as ISupplementaryApplicationFormStep1).formerPepDate = data.formerPepDate;
    if (data.familyPep) (dto as ISupplementaryApplicationFormStep1).familyPep = data.familyPep;
    if (data.familyPepRelationship) (dto as ISupplementaryApplicationFormStep1).familyPepRelationship = data.familyPepRelationship;
    if (data.familyPepPosition) (dto as ISupplementaryApplicationFormStep1).familyPepPosition = data.familyPepPosition;
    if (data.familyPepDate) (dto as ISupplementaryApplicationFormStep1).familyPepDate = data.familyPepDate;
    if (data.closeAssociatePep) (dto as ISupplementaryApplicationFormStep1).closeAssociatePep = data.closeAssociatePep;
    if (data.closeAssociatePepRelationship)
      (dto as ISupplementaryApplicationFormStep1).closeAssociatePepRelationship = data.closeAssociatePepRelationship;
    if (data.closeAssociatePepPosition) (dto as ISupplementaryApplicationFormStep1).closeAssociatePepPosition = data.closeAssociatePepPosition;
    if (data.closeAssociatePepDate) (dto as ISupplementaryApplicationFormStep1).closeAssociatePepDate = data.closeAssociatePepDate;

    return dto;
  };
  static transformSupplementaryApplicationFormStep2 = (data: SupplementaryApplicationEntity): ISupplementaryApplicationFormStep2 => {
    return {
      acceptedTC: data.acceptedTC || false,
    };
  };

  static defaultApplication: ApplicationEntity = {
    // OTHER XZ
    mainCardLast4Digits: '',
    relationshipToMain: '',
    id: '',
    insertedDate: '',
    processedDate: '',
    deletedDate: '',
    deleted: false,
    supplement: false,
    alternateCity: '',
    alternatePostcode: '',
    alternativeCountry: '',
    // STEP SECURITY
    partnerAccountManagerId: '',
    partnerAccountManagerName: '',
    ippGroup: '',
    // STEP PRODUCT
    productName: '',
    fee: true,
    // STEP CURRENCY
    eurCurrency: false,
    eurCreditLimit: '',
    chfCurrency: false,
    chfCreditLimit: '',
    usdCurrency: false,
    usdCreditLimit: '',
    // STEP APPLICANT
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    nameOnCard: '',
    nationality: '',
    countryOfBirth: '',
    maritalStatus: '',
    dob: '',
    passport_IDCardNo: '',
    countryOfIssuance: '',
    passportExpiryDate: '',
    nationalities: [''],
    // STEP CONTACT
    residentialAddressLine1: '',
    residentialAddressLine2: '',
    city: '',
    postcode: '',
    country: '',
    alternativeMailingAddressLine1: '',
    alternativeMailingAddressLine2: '',
    alternativeMailingAddressCity: '',
    alternativeMailingAddressPostcode: '',
    alternativeMailingAddressCountry: '',
    // STEP EMPLOYMENT
    employmentStatus: '',
    employmentStatusOther: '',
    positionHeld: '',
    companyName: '',
    employmentDuration: '',
    natureOfBusiness: '',
    companyWebsite: '',
    mobileAreaCode: '',
    mobileNumber: '',
    alternateAreaCode: '',
    alternativeContactNumber: '',
    email: '',
    deliveryAddress: '',
    deliveryBordierOffice: '' as BordierOffice,
    // STEP LIFESTYLE MANAGEMENT
    personalAssistantLanguage: '',
    // STEP FINANCIAL DETAILS
    annualIncomeCurrency: '',
    annualIncomeAmount: '',
    otherIncomeCurrency: '',
    otherIncomeAmount: '',
    sow: [{} as SourceOfWealthValue],
    sof: [{} as SourceOfWealthValue],
    // netWorth: '' as NetWorth,
    bankAccountNumber: '',
    bankAccountNumber2: '',
    anticipatedMonthlySpend: '' as AnticipatedMonthlySpend,
    // STEP PEP
    pep: false,
    pepRolePosition: '',
    // currentPepDate: '',
    // formerPep: false,
    // formerPepPosition: '',
    // formerPepDate: '',
    // familyPep: false,
    // familyPepRelationship: '',
    // familyPepPosition: '',
    // familyPepDate: '',
    // closeAssociatePep: false,
    // closeAssociatePepRelationship: '',
    // closeAssociatePepPosition: '',
    // closeAssociatePepDate: '',
    // STEP SECURITY QUESTION
    securityQuestion: '',
    securityAnswer: '',
    // STEP COMMUNICATION PREFERENCES
    fraudSMS: false,
    creditLimit80PerCentSMS: false,
    allTransactionsSMS: false,
    marketing: false,
    acceptedTC: false,
  };
  static defaultApplicationFormStep1: IApplicationFormStep1 = {
    // STEP SECURITY
    partnerAccountManagerId: '',
    partnerAccountManagerName: '',
    ippGroup: '',
    // STEP PRODUCT
    productName: '',
    fee: false,
    // STEP CURRENCY
    eurCurrency: false,
    eurCreditLimit: '',
    chfCurrency: false,
    chfCreditLimit: '',
    usdCurrency: false,
    usdCreditLimit: '',
    // STEP APPLICANT
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    nameOnCard: '',
    nationality: '',
    countryOfBirth: '',
    maritalStatus: '',
    dob: '',
    passport_IDCardNo: '',
    countryOfIssuance: '',
    passportExpiryDate: '',
    nationalities: [''],
    // STEP CONTACT
    residentialAddressLine1: '',
    residentialAddressLine2: '',
    city: '',
    postcode: '',
    country: '',
    alternativeMailingAddressLine1: '',
    alternativeMailingAddressLine2: '',
    alternativeMailingAddressCity: '',
    alternativeMailingAddressPostcode: '',
    alternativeMailingAddressCountry: '',
    // STEP EMPLOYMENT
    employmentStatus: '',
    employmentStatusOther: '',
    positionHeld: '',
    companyName: '',
    employmentDuration: '',
    natureOfBusiness: '',
    companyWebsite: '',
    mobileAreaCode: '',
    mobileNumber: '',
    alternateAreaCode: '',
    alternativeContactNumber: '',
    email: '',
    deliveryAddress: '',
    deliveryBordierOffice: '' as BordierOffice,
    // STEP LIFESTYLE MANAGEMENT
    personalAssistantLanguage: '',
    // STEP FINANCIAL DETAILS
    annualIncomeCurrency: '',
    annualIncomeAmount: '',
    otherIncomeCurrency: '',
    otherIncomeAmount: '',
    sow: [{} as SourceOfWealthValue],
    sof: [{} as SourceOfWealthValue],
    // netWorth: '' as NetWorth,
    bankAccountNumber: '',
    bankAccountNumber2: '',
    anticipatedMonthlySpend: '' as AnticipatedMonthlySpend,
    // STEP PEP
    pep: false,
    pepRolePosition: '',
    // currentPepDate: '',
    // formerPep: false,
    // formerPepPosition: '',
    // formerPepDate: '',
    // familyPep: false,
    // familyPepRelationship: '',
    // familyPepPosition: '',
    // familyPepDate: '',
    // closeAssociatePep: false,
    // closeAssociatePepRelationship: '',
    // closeAssociatePepPosition: '',
    // closeAssociatePepDate: '',
    // STEP SECURITY QUESTION
    securityQuestion: '',
    securityAnswer: '',
  };
  static defaultApplicationFormStep2: IApplicationFormStep2 = {
    // STEP COMMUNICATION PREFERENCES
    fraudSMS: false,
    creditLimit80PerCentSMS: false,
    allTransactionsSMS: false,
    marketing: false,
    acceptedTC: false,
  };
  static transformCustomerApplication = ({
    customerId,
    customerApplication,
  }: {
    customerId: string;
    customerApplication: ApplicationCustomerDetailsEntity;
  }) => {
    let securityQuestion = '';
    if (customerApplication.securityQuestion === 'What is the name of your first school?') securityQuestion = 'First School';
    else if (customerApplication.securityQuestion === 'What street did you grow up on?') securityQuestion = 'Street';
    else if (customerApplication.securityQuestion === 'In what city or town was your first job?') securityQuestion = 'First Job';
    else if (customerApplication.securityQuestion) securityQuestion = customerApplication.securityQuestion;
    return {
      customerId,
      title: customerApplication.title,
      firstName: customerApplication.firstname,
      middleName: customerApplication.middlename,
      lastName: customerApplication.lastname,
      dob: customerApplication.dateOfBirth,
      nationality: customerApplication.nationality,
      maritalStatus: customerApplication.maritalStatus,
      passport_IDCardNo: customerApplication.passport,
      countryOfIssuance: customerApplication.passportCountry,
      passportExpiryDate: customerApplication.passportExpiryDate,
      residentialAddressLine1: customerApplication.residentialAddressLine1,
      residentialAddressLine2: customerApplication.residentialAddressLine2,
      city: customerApplication.residentialAddressCity,
      postcode: customerApplication.residentialAddressPostcode,
      country: customerApplication.residentialAddressCountry,
      email: customerApplication.email,
      employmentStatus: customerApplication.employmentStatus,
      positionHeld: customerApplication.positionHeld,
      companyName: customerApplication.companyName,
      employmentDuration: customerApplication.employmentDurationDays?.toString() || '',
      natureOfBusiness: customerApplication.natureOfBusiness,
      companyWebsite: customerApplication.companyWebsite,
      annualIncomeCurrency: customerApplication.currency,
      annualIncomeAmount: customerApplication.annualIncomeAmount?.toString() || '',
      otherIncomeCurrency: customerApplication.otherIncomeAmountCurrency,
      sow: customerApplication.sow,
      sof: customerApplication.sof,
      securityQuestion,
    };
  };
  static transformApplicationFormStep1 = (data: ApplicationEntity): IApplicationFormStep1 => {
    const dto = {
      partnerAccountManagerId: data.partnerAccountManagerId || '',
      partnerAccountManagerName: data.partnerAccountManagerName || '',
      ippGroup: data.ippGroup || '',
      productName: data.productName || '',
      fee: data.fee || false,
      eurCurrency: data.eurCurrency || false,
      eurCreditLimit: data.eurCreditLimit || '',
      chfCurrency: data.chfCurrency || false,
      chfCreditLimit: data.chfCreditLimit || '',
      usdCurrency: data.usdCurrency || false,
      usdCreditLimit: data.usdCreditLimit || '',
      title: data.title || '',
      firstName: data.firstName || '',
      middleName: data.middleName || '',
      lastName: data.lastName || '',
      nameOnCard: data.nameOnCard || '',
      nationality: data.nationality || '',
      countryOfBirth: data.countryOfBirth || '',
      maritalStatus: data.maritalStatus || '',
      dob: data.dob || '',
      passport_IDCardNo: data.passport_IDCardNo || '',
      countryOfIssuance: data.countryOfIssuance || '',
      passportExpiryDate: data.passportExpiryDate || '',
      nationalities: data.nationalities || [''],
      residentialAddressLine1: data.residentialAddressLine1 || '',
      residentialAddressLine2: data.residentialAddressLine2 || '',
      city: data.city || '',
      postcode: data.postcode || '',
      country: data.country || '',
      alternativeMailingAddressLine1: data.alternativeMailingAddressLine1 || '',
      alternativeMailingAddressLine2: data.alternativeMailingAddressLine2 || '',
      alternativeMailingAddressCity: data.alternativeMailingAddressCity || '',
      alternativeMailingAddressPostcode: data.alternativeMailingAddressPostcode || '',
      alternativeMailingAddressCountry: data.alternativeMailingAddressCountry || '',
      employmentStatus: data.employmentStatus || '',
      employmentStatusOther: data.employmentStatusOther || '',
      positionHeld: data.positionHeld || '',
      companyName: data.companyName || '',
      employmentDuration: data.employmentDuration || '',
      natureOfBusiness: data.natureOfBusiness || '',
      companyWebsite: data.companyWebsite || '',
      mobileAreaCode: data.mobileAreaCode || '',
      mobileNumber: data.mobileNumber || '',
      alternateAreaCode: data.alternateAreaCode || '',
      alternativeContactNumber: data.alternativeContactNumber || '',
      email: data.email || '',
      deliveryAddress: data.deliveryAddress || '',
      deliveryBordierOffice: data.deliveryBordierOffice || ('' as BordierOffice),
      personalAssistantLanguage: data.personalAssistantLanguage || '',
      annualIncomeCurrency: data.annualIncomeCurrency || '',
      annualIncomeAmount: data.annualIncomeAmount || '',
      otherIncomeCurrency: data.otherIncomeCurrency || '',
      otherIncomeAmount: data.otherIncomeAmount || '',
      sow: data.sow || [{}],
      sof: data.sof || [{}],
      // netWorth: data.netWorth || ('' as NetWorth),
      bankAccountNumber: data.bankAccountNumber || '',
      bankAccountNumber2: data.bankAccountNumber2 || '',
      anticipatedMonthlySpend: data.anticipatedMonthlySpend || ('' as AnticipatedMonthlySpend),
      pep: data.pep || false,
      pepRolePosition: data.pepRolePosition || '',
      // currentPepDate: data.currentPepDate || '',
      // formerPep: data.formerPep || false,
      // formerPepPosition: data.formerPepPosition || '',
      // formerPepDate: data.formerPepDate || '',
      // familyPep: data.familyPep || false,
      // familyPepRelationship: data.familyPepRelationship || '',
      // familyPepPosition: data.familyPepPosition || '',
      // familyPepDate: data.familyPepDate || '',
      // closeAssociatePep: data.closeAssociatePep || false,
      // closeAssociatePepRelationship: data.closeAssociatePepRelationship || '',
      // closeAssociatePepPosition: data.closeAssociatePepPosition || '',
      // closeAssociatePepDate: data.closeAssociatePepDate || '',
      securityQuestion: data.securityQuestion || '',
      securityAnswer: data.securityAnswer || '',
    };
    if (data.netWorth) (dto as IApplicationFormStep1).netWorth = data.netWorth;
    if (data.currentPepDate) (dto as IApplicationFormStep1).currentPepDate = data.currentPepDate;
    if (data.formerPep) (dto as IApplicationFormStep1).formerPep = data.formerPep;
    if (data.formerPepPosition) (dto as IApplicationFormStep1).formerPepPosition = data.formerPepPosition;
    if (data.formerPepDate) (dto as IApplicationFormStep1).formerPepDate = data.formerPepDate;
    if (data.familyPep) (dto as IApplicationFormStep1).familyPep = data.familyPep;
    if (data.familyPepRelationship) (dto as IApplicationFormStep1).familyPepRelationship = data.familyPepRelationship;
    if (data.familyPepPosition) (dto as IApplicationFormStep1).familyPepPosition = data.familyPepPosition;
    if (data.familyPepDate) (dto as IApplicationFormStep1).familyPepDate = data.familyPepDate;
    if (data.closeAssociatePep) (dto as IApplicationFormStep1).closeAssociatePep = data.closeAssociatePep;
    if (data.closeAssociatePepRelationship) (dto as IApplicationFormStep1).closeAssociatePepRelationship = data.closeAssociatePepRelationship;
    if (data.closeAssociatePepPosition) (dto as IApplicationFormStep1).closeAssociatePepPosition = data.closeAssociatePepPosition;
    if (data.closeAssociatePepDate) (dto as IApplicationFormStep1).closeAssociatePepDate = data.closeAssociatePepDate;

    return dto;
  };
  static transformApplicationFormStep2 = (data: ApplicationEntity): IApplicationFormStep2 => {
    return {
      fraudSMS: data.fraudSMS || false,
      creditLimit80PerCentSMS: data.creditLimit80PerCentSMS || false,
      allTransactionsSMS: data.allTransactionsSMS || false,
      marketing: data.marketing || false,
      acceptedTC: data.acceptedTC || false,
    };
  };
  static transformFormToApplication = (data: ApplicationEntity): ApplicationEntity => {
    const dto = { ...data };
    if (!data.netWorth) delete dto.netWorth;
    if (!data.currentPepDate) delete dto.currentPepDate;
    if (!data.formerPep) delete dto.formerPep;
    if (!data.formerPepPosition) delete dto.formerPepPosition;
    if (!data.formerPepDate) delete dto.formerPepDate;
    if (!data.familyPep) delete dto.familyPep;
    if (!data.familyPepRelationship) delete dto.familyPepRelationship;
    if (!data.familyPepPosition) delete dto.familyPepPosition;
    if (!data.familyPepDate) delete dto.familyPepDate;
    if (!data.closeAssociatePep) delete dto.closeAssociatePep;
    if (!data.closeAssociatePepRelationship) delete dto.closeAssociatePepRelationship;
    if (!data.closeAssociatePepPosition) delete dto.closeAssociatePepPosition;
    if (!data.closeAssociatePepDate) delete dto.closeAssociatePepDate;

    return dto;
  };
}
